// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"706":"0b0a2497","813":"0aa2e028"}[chunkId] + ".chunk.css";
};